import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import { Box, Chip } from '@mui/material';

const STATUS_TRANSLATIONS: Record<string, { label: string; color: any }> = {
  ACTIVE: { label: 'Ativo', color: 'success' },
  INACTIVE: { label: 'Inativo', color: 'default' },
  MAINTENANCE: { label: 'Manutenção', color: 'warning' },
};

function getColumns(onView: (row: any) => void) {
  return [
    { field: 'name', headerName: 'Nome', flex: 1 },
    { field: 'description', headerName: 'Descrição', flex: 1.5 },
    {
      field: 'is_enabled_virtual_key',
      headerName: 'Chave Virtual',
      width: 150,
      renderCell: (params: any) => {
        const virtualKey = params.row.is_enabled_virtual_key;
        return (
          <Chip
            label={virtualKey ? 'Habilitada' : 'Desabilitada'}
            color={virtualKey ? 'success' : 'warning'}
            size="small"
            variant="outlined"
          />
        );
      }
    },
    {
      field: 'schedules',
      headerName: 'Horários',
      width: 250,
      renderCell: (params: any) => {
        const schedules = params.row.schedules || [];
        const status = params.row.status || 'ACTIVE';
        const statusInfo = STATUS_TRANSLATIONS[status] || { label: status, color: 'default' };
        const activeSchedules = schedules.filter((s: any) => s.is_active);

        if (activeSchedules.length === 0) {
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                label={'Sem horários'}
                color={statusInfo.color}
                size="small"
                variant="outlined"
              />
            </Box>
          );
        }

        const workingDays = activeSchedules.filter((s: any) =>
          !(s.start_time === '00:00:00' && s.end_time === '00:00:00')
        ).length;

        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip
              label={`${workingDays} dia${workingDays > 1 ? 's configurados' : 'configurado'}`}
              color={statusInfo.color}
              size="small"
              variant="outlined"
            />
          </Box>
        );
      }
    },
    { field: 'tenant_name', headerName: 'Empresa', flex: 1 },
  ];
}

interface RoomTableProps {
  rows: any[];
  loading: boolean;
  onView: (row: any) => void;
}

export function RoomTable({ rows, loading, onView }: RoomTableProps) {
  const columns = getColumns(onView);
  return (
    <DatabaseTable
      rows={rows}
      columns={columns}
      loading={loading}
      onView={onView}
      hideDelete
      hideEdit
    />
  );
} 